export enum EditCollectionTab {
    Basics = "basics",
    Content = "content",
    Preview = "preview",
}
